import { AbstractMessageCommand } from 'flux-connection';
import { Injectable } from '@angular/core';
import { DataStore } from 'flux-store';
import { CommandInterfaces, Command } from 'flux-core';
import { DiagramInfoModel, DiagramInfoModelStore } from 'flux-diagram';
import { Observable, of } from 'rxjs';
import { tap, map, switchMap } from 'rxjs/operators';

/**
 * This is the command which changes the role of the diagram collaborator and send
 * the request to the server.
 *
 * data: {
 *     collabs { id, role} An array of changed collaborator id and role
 *     diagramId id of the resource
 * }
 */
@Injectable()
@Command()
export class ChangeDiagramCollaborators extends AbstractMessageCommand  {

    public static get dataDefinition(): {}  {
        return {
            collabs: true,
            diagramId: true,
        };
    }

    public static get implements(): Array<CommandInterfaces> {
        return [
            'IMessageCommand',
            'IDiagramCommand',
        ];
    }

    constructor( protected dataStore: DataStore ) {
        super()/* istanbul ignore next */;
    }

    public get version(): number {
        return 2;
    }

    public prepareData() {
        this.previousData = {};
        const modelStore = this.dataStore.getModelStore( DiagramInfoModel ) as DiagramInfoModelStore;
        return modelStore.getCollabs( this.data.diagramId ).pipe(
            tap( collaborators => {
                this.previousData.collabs = collaborators.filter( collab =>
                    this.data.collabs.map( user => user.id ).indexOf( collab.id ) !== -1 );
            }),
        );
    }

    /**
     * execute
     * change collaborator role
     */
    public execute(): Observable<any> {
        const modelStore = this.dataStore.getModelStore( DiagramInfoModel ) as DiagramInfoModelStore;

        return of( this.previousData.collabs ).pipe(
            map( collaborators => {
                const updateCollabs = [];
                this.data.collabs.forEach( collab  => {
                    const collabData = collaborators.filter( collaborator => collaborator.id === collab.id )[0];
                    collabData.role = collab.role;
                    updateCollabs.push( collabData );
                });
                return updateCollabs;
            }),
            switchMap( collabs => modelStore.storageMergeCollabs( this.data.diagramId, collabs )),
        );
    }

    /**
     * executeResult
     * Update the collaborators with the response
     */
    public executeResult( response: any ): Observable<any> {
        const modelStore = this.dataStore.getModelStore( DiagramInfoModel ) as DiagramInfoModelStore;
        return modelStore
            .storageMergeCollabs( this.resourceId, response.collabs );
    }


    public revert(): Observable<any> {
        const modelStore = this.dataStore.getModelStore( DiagramInfoModel ) as DiagramInfoModelStore ;
        return modelStore.storageMergeCollabs( this.data.diagramId, this.previousData.collabs );
    }

}

Object.defineProperty( ChangeDiagramCollaborators, 'name', {
    value: 'ChangeDiagramCollaborators',
});
